import { isTRPCClientError } from '@trpc/client';

import type { AppRouter } from './router.types';

/**
 * 이메일 인증을 아직 마치지 않은 계정.
 *
 * 서버가 실어 보내는 값과 **같은 문자열**을 유지한다
 * (`apps/api/src/modules/auth/router/transport-error.ts` 의 `TRANSPORT_REASON`).
 * `CONSENT_VERSION` 과 같은 방식이다 — 값으로 import 하면 프론트 번들에 api 가 딸려 온다.
 */
export const EMAIL_NOT_VERIFIED = 'EMAIL_NOT_VERIFIED';

/**
 * 로그인이 "아직 인증하지 않은 계정" 때문에 막혔는지.
 *
 * **상태코드로 판단하면 안 된다.** 미인증·차단·탈퇴가 모두 403 으로 오는데, 셋 중
 * 사용자가 무언가 할 수 있는 것은 미인증뿐이다. 상태코드만 보면 차단된 사람에게도
 * "인증 메일 다시 받기"를 권하게 된다.
 *
 * **문구로 판단해도 안 된다.** 서버 문장을 다듬는 날 조용히 다른 갈래로 새고,
 * 그때도 테스트는 전부 통과한다. 그래서 서버가 따로 실어 보내는 사유 코드를 본다.
 */
export const isEmailNotVerified = (error: unknown): boolean =>
  isTRPCClientError<AppRouter>(error) && error.data?.reason === EMAIL_NOT_VERIFIED;

/**
 * 서버가 붙인 전송 코드(`CONFLICT` · `FORBIDDEN` …).
 *
 * HTTP 상태가 아니라 이 값을 본다 — 요청을 묶어 보내면(httpBatchLink) 섞인 응답이
 * 207 로 오고, 그 안의 409 는 상태 코드만 봐서는 보이지 않는다.
 */
export const errorCodeOf = (error: unknown): string | undefined =>
  isTRPCClientError<AppRouter>(error) ? error.data?.code : undefined;
